import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../Contexts/AuthContext";
import logo from "../../../images/pngegg.png";
import "./Navbar.css";

const Navbar = () => {
  const { currentUser, signOut } = useAuth();
  const handleSignOut = () => {
    signOut();
  };

  return (
    <nav className="container navbar navbar-expand-lg navbar-light">
      <div className="container-fluid">
        <a className="navbar-brand" href="">
          <img src={logo} alt="" width="5%" />
        </a>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item d-flex mr-auto">
              <a className="nav-link  " aria-current="page" href="/">
                Home
              </a>
            </li>
            <li>
              <a className="nav-link " aria-current="page" href="/">
                Facilities
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link " aria-current="page" to="/dashboard">
                Dashboard
              </Link>
            </li>

            {currentUser ? (
              <li className="nav-item">
                <Link onClick={handleSignOut} to="/">
                  Log_Out
                </Link>
              </li>
            ) : (
              <li className="nav-item">
                <Link to="/login">Login</Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
